//LHB
import useDecodeToken from "@/utils/hooks/useDecodeJwt";
import dataManagement from "@/navigation/data-management";
import inventory from "@/navigation/inventory";
import privileges from "@/navigation/privileges";
import report from "@/navigation/report";
import banner from "@/navigation/banner";
import tags from "@/navigation/tags";
import fulfillment from "@/navigation/fulfillment";
import document from "@/navigation/document";
import article from "@/navigation/article";
import flashdeal from "@/navigation/flashdeal";

//Ovaltine Club Custom module
import customReport from "@/constants/navigation/B2PT41TG5C9L/menu/custom-report";

const { decodeToken } = useDecodeToken();
const renderNavByPermission = () => {
  switch (decodeToken()?.provider_ref) {
    case "PVuEEYeD1fHsoS": //dev LHB BO UP
    case "PV5No3bbru9aPS": //prod LHB BO EP
      switch (decodeToken()?.sub) {
        case "ID_uu5wa3aep6i8": //dev thiraphatk@lhbank.co.th
        case "ID_6U06DwPWq4jn": //dev thanakornka@lhbank.co.th
        case "ID_3YWHDyHbaAFV": //prod thiraphatk@lhbank.co.th
        case "ID_9yJiSN7XXKHA": //prod thanakornka@lhbank.co.th
        case "ID_8Xn4QG6YgYrp": //prod sasipattp@lhbank.co.th
        case "ID_OC5pFAYjrtJj": //prod suwaleek@lhbank.co.th
          return [...report];
        case "ID_JLi0HcFgfRKX": //prod PhassarunN@lhbank.co.th
          return [...report];
      }
    default:
      return [
        //dev
        // ...inventory,
        // ...privileges,
        // ...banner,
        // ...tags,
        // ...dataManagement,
        // ...fulfillment,
        // ...report,

        //prod
        ...dataManagement,
        ...banner,
        ...privileges,
        ...inventory,
        ...fulfillment,
        ...tags,
        ...report,
        ...article,
        ...document,
        ...flashdeal,
        ...customReport
      ];
  }
};

export default renderNavByPermission();
